import BaseNextImage, { BaseNextImageProps } from './BaseNextImage';
import FixedNextImage from './FixedNextImage';

interface DynamicNextImageProps
  extends Omit<
    BaseNextImageProps,
    'fill' | 'preventStretch' | 'imagePositionRelative' | 'width' | 'height'
  > {
  width?: number | undefined;
  height?: number | undefined;
}

const DynamicNextImage = ({
  src,
  alt,
  crop,
  smartCrop,
  skipUrlProcessing = false,
  loading = 'lazy',
  imageFit = 'scaleDown',
  width,
  height,
  ...rest
}: DynamicNextImageProps) => {
  if (width && height) {
    return (
      <FixedNextImage
        src={src || ''}
        alt={alt}
        crop={crop}
        smartCrop={smartCrop}
        skipUrlProcessing={skipUrlProcessing}
        loading={loading}
        imageFit={imageFit}
        width={width}
        height={height}
        {...rest}
      />
    );
  }

  return (
    <BaseNextImage
      src={src || ''}
      alt={alt}
      crop={crop}
      smartCrop={smartCrop}
      skipUrlProcessing={skipUrlProcessing}
      loading={loading}
      fill
      imagePositionRelative
      preventStretch
      imageFit={imageFit}
      {...rest}
    />
  );
};

export default DynamicNextImage;
